import React from 'react';
import moment from 'moment';
import _ from 'lodash';

import { withUserImages } from '../hoc/editor';
import { FlatButton, IconButton } from 'material-ui';
import IconLeft from 'material-ui/svg-icons/navigation/chevron-left';
import IconRight from 'material-ui/svg-icons/navigation/chevron-right';
import ImageUploaderContainer from 'dash-front/components/ImageUploaderContainer';
import { withStateHandlers } from 'recompose';

const ImagesPreview = withStateHandlers(
    {
        showUploader: false,
    },
    {
        displayUploader: () => showUploader => ({
            showUploader,
        }),
    },
)(({ data, images = [], next, doRefreshImages, prev, offset, limit, showUploader, displayUploader }) => (
    <div
        style={{
            display: 'flex',
            flexDirection: 'wrap',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
        }}
    >
        <IconButton disabled={offset == 0} onClick={() => prev()}>
            <IconLeft />
        </IconButton>
        <div style={{ flexGrow: 1, height: 50 }} />
        <IconButton disabled={offset + limit >= data.length} onClick={() => next()}>
            <IconRight />
        </IconButton>

        <div
            style={{
                display: 'flex',
                flexDirection: 'wrap',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            {_.chain(images)
                .orderBy(i => -moment(i.createdAt))
                .map(({ cdnUrl, name, thumbs: [thumb] }) => (
                    <img
                        alt={name}
                        style={{
                            width: 112,
                            height: 112,
                            marginBottom: 15,
                            border: '1px solid #fff',
                            objectFit: 'cover',
                            cursor: 'grab',
                        }}
                        onDragStart={e => {
                            e.dataTransfer.setData('url', cdnUrl);
                        }}
                        key={thumb.url}
                        src={thumb.url}
                    />
                ))
                .value()}
        </div>

        <FlatButton
            label="Upload image"
            style={{ width: '100%' }}
            onClick={() => {
                displayUploader(true);
            }}
        />

        {showUploader && (
            <ImageUploaderContainer
                onClose={() => {
                    displayUploader(false);
                    doRefreshImages();
                }}
                modal
                showGallery={false}
            />
        )}
    </div>
));

export default withUserImages(ImagesPreview);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/containers/FastImagePicker.js
 **/